import { render, staticRenderFns } from "./VolunteerMatchStatus.vue?vue&type=template&id=138b9462"
import script from "./VolunteerMatchStatus.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchStatus.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchStatus.vue?vue&type=style&index=0&id=138b9462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports